var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9498 15.5356C17.9498 16.0879 17.5021 16.5356 16.9498 16.5356C16.3975 16.5356 15.9498 16.0879 15.9498 15.5356L15.9498 9.46455L7.75743 17.6569C7.36691 18.0475 6.73375 18.0475 6.34322 17.6569C5.9527 17.2664 5.9527 16.6333 6.34322 16.2427L14.5356 8.05034H8.46454C7.91226 8.05034 7.46454 7.60263 7.46454 7.05034C7.46454 6.49806 7.91226 6.05034 8.46454 6.05034H16.9498C17.5021 6.05034 17.9498 6.49806 17.9498 7.05034L17.9498 15.5356Z",
    fill: "black"
  })));
};
export { SvgArrowUpRight as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up-right.2214eea0.svg";